import Vue from 'vue';
import VueI18n from 'vue-i18n';

Vue.use(VueI18n);

const messages = {
  ar: {
    admissionsTitle: ' الإقرارات',
    admissionEmptyListTitle: 'لا يوجد إقرارت لعرضها',
    filter: 'تصفية النتائج',
    advancedfilter: 'البحث المتقدم',
    CreateNewWekala: 'إنشاء وكالة جديدة',
    CopyWekala: 'نسخ وكالة سابقة',
    CopyWekalaPartiesAndClauses: 'نسخ البنود والوكلاء',
    CopyWekalaSecondParties: 'نسخ الوكلاء',
    CopyWekalaFirstParties: 'نسخ الموكلين',
    CopyWekalaClauses: 'نسخ البنود',
    CopyIssueSingle: 'وكالة فردية',
    CopyIssueGrouped: 'وكالة متعددة الأطراف',
    Yes: 'نعم',
    No: 'لا',
    CanCreateBemogab: 'يحق لهم توكيل الغير',
    CanCreateBemogabOne: 'يحق للوكيل توكيل الغير',
    ExternalCanCreateBemogabOne: 'يحق للوكيل فى الوكالة الخارجية توكيل الغير',
    CanCreateBemogabPlural: 'يحق للوكلاء توكيل الغير',
    ExternalCanCreateBemogabPlural: 'يحق للوكلاء فى الوكالة الخارجية توكيل الغير',
    wakelStatus: 'حالة الوكلاء فى الوكالة',
    ExternalwakelStatus: 'حالة الوكلاء فى الوكالة الخارجية',
    together: 'مجتمعين',
    single: 'منفردين',
    CopyWekalaType: 'نوع النسخ',
    CopyWekalaNewType: 'نوع الوكالة المُراد إصدارها',
    OpenTextCopiedClausesWarning:
      'تم قراءة جميع بنود الوكالة بما فيها النصوص المفتوحة',
    anonymousUserVerificationFailedException:
      'رمز التحقق خاطئ, يرجى المحاولة مرة أخرى',
    procurationsVerification: {
      procurationNumber2: 'وكالة رقم',
      viewMoreDetails: 'المزيد من التفاصيل',
      nationality: 'الجنسية',
      subwekala: 'الوكالات الفرعية',
      subwekalaDetail: 'تفاصيل الوكالة الفرعية',
      title: 'بيانات التحقق',
      description: 'خدمة تساعدك على التحقق من صحة الوكالة',
      procurationNumber: 'رقم الوكالة',
      idNumber: 'رقم الهوية',
      idType: 'نوع الهوية',
      showSubWekala: 'الوكالات الفرعية',
      procurationData: 'بيانات الوكالة',
      issueDate: 'تاريخ إصدار الوكالة',
      issueDateTasdek: 'تاريخ إصدار التصديق',
      endDate: 'تاريخ انتهاء الوكالة',
      status: 'الحالة',
      use: 'كيفية الاستخدام',
      notaryName: 'كاتب العدل',
      issuer: 'جهة الإصدار',
      issuerTasdek: 'جهة تصديق الوكالة',
      partiesData: 'بيانات الأطراف',
      agent: 'موكل',
      adjective: 'الصفة',
      partyStatus: 'حالته بالوكالة',
      GroupedpartyStatus: 'حالته بالطلب',
      client: 'وكيل',
      agencyTerms: 'بنود الوكالة',
      eventLog: 'سجل الأحداث',
      dateTime: 'التاريخ والوقت',
      agentParty: 'الطرف',
      noEvent: 'لا يوجد بيانات لعرضها',
      submit: 'تحقق',
      verfiy: 'تحقق',
      back: 'العودة للبوابة',
      backVerification: 'تحقق جديد',
      writeProcurationNumber: 'رقم الوكالة',
      writeIdNumber: 'رقم الهوية',
      validateTrue: 'تم التحقق بنجاح',
      noAgencyTerms: 'لا يوجد بنود',
      download: 'تحميل الوكالة',
      warning: 'رقم الوكالة أو رقم هوية أحد الأطراف غير صحيح',
      valid: 'الصلاحية',
      partiesInfo: 'بيانات الأطراف',
      source: 'المصدر',
      issuePlace: 'مكان الإصدار',
      minorInfo: 'بيانات القاصر',
      verifierIdNumber: 'رقم هوية المتحقق',
      procurationText: 'نص الوكالة',
      emptyProcurationText: 'لا يوجد نص الوكالة',
      numberOfSubWekala: 'عدد الوكالات الفرعية',
      FingurePrintSuccessVerify: 'تم التحقق بنجاح من البصمة'
    },
    externalWekala: {
      externalTasdekNumber: 'رقم تصديق الوكالة',
      externalCountryIssue: 'الدولة المصدرة',
      externalTasdekentity: 'جهة تصديق الوكالة',
      externalTasdekKharijyaDate:
        'تاريخ تصديق وزارة الخارجية للدولة المصدرة للوكالة',
      externalTasdekMofaKharijyaDate: 'تاريخ تصديق وزارة الخارجية السعودية',
      externalWekalaNumber: 'رقم الوكالة الخارجية',
      externalTasdekDate: 'تاريخ إصدار التصديق',
      externalWekalaSource: 'مصدر الوكالة الخارجية',
      externalIssueDate: 'تاريخ إصدار الوكالة الخارجية',
      externalExpiryDate: 'تاريخ انتهاء الوكالة الخارجية',
      externalInternalExpiryDate: 'تاريخ انتهاء التصديق',
      externaEmbasadyDate: 'تاريخ تصديق السفارة أو القنصلية السعودية',
      email: 'البريد الإلكتروني'
    },
    validation: {
      required: 'هذا الحقل مطلوب',
      mobilestartWith05: '%{_field_} يجب أن يبدأ بـ %{start}',
      minLength: ' %{_field_} يجب أن يتكون من %{length} أرقام '
    },
    externalTasdek: {
      title: 'تصديق وكالة خارجية',
      requesterInfo: 'بيانات مقدم الطلب',
      firstPartyInfo: 'بيانات الموكل',
      secondPartyInfo: 'بيانات الوكيل',
      externalWekalaInfo: 'بيانات الوكالة الخارجية',
      externalWekalafirstPartyInfo: 'بيانات الموكل فى الوكالة الخارجية',
      externalWekalaSecondPartyInfo: 'بيانات الوكيل فى الوكالة الخارجية',
      externalWekalaInfoHeader: 'بيانات الوكالة الخارجية',
      requestPreview: 'معاينة الطلب',
      copyMyDataAsfirstParty: 'نسخ بياناتي كطرف موكل',
      copyMyDataAsSecondParty: 'نسخ بياناتي كطرف وكيل',
      AddNewSecondParty: 'إضافة وكيل جديد',
      AddNewFirstParty: 'إضافة موكل جديد',
      externalWekalaIssueCountryTasdekDateShouldNotFuture:
        'تاريخ تصديق وزارة الخارجية للدولة المصدرة للوكالة لا يمكن أن يكون أكبر من تاريخ اليوم.',
      externalWekalaSaudiTasdekDateShouldNotFuture:
        'تاريخ تصديق السفارة او القنصلية السعودية لا يمكن أن يكون أكبر من تاريخ اليوم.',

      externalWekalaMofaTasdekDateShouldNotFuture:
        'تاريخ تصديق وزارة الخارجية السعودية لا يمكن أن يكون أكبر من تاريخ اليوم.',

      externalWekalaIssueDateShouldNotFuture:
        'تاريخ إصدار الوكالة خارجية لا يمكن أن يكون أكبر من تاريخ اليوم.',

      externalWekalaEndDateShouldNotPast: 'لا يمكن تصديق وكالة خارجية منتهية',

      externalWekalaIssueDateShouldNotLessTahn5Years: 'لايمكن تصديق وكالة تم اصدارها قبل 5 سنوات من اليوم حيث أن الأنظمة المطبقة في المملكة العربية السعودية تنص على ذلك',

      externalWekalaIssueCountrybeforeIssueDate:
        'تاريخ تصديق وزارة الخارجية للدولة المصدرة للوكالة لا يمكن أن يكون قبل تاريخ إصدار الوكالة.',

      externalWekalaSaudiTasdekDatebeforeIssueDate:
        'تاريخ تصديق السفارة او القنصلية السعودية لا يمكن أن يكون قبل تاريخ إصدار الوكالة.',

      externalWekalaMofaTasdekDatebeforeIssueDate:
        'تاريخ تصديق وزارة الخارجية السعودية لا يمكن أن يكون قبل تاريخ إصدار الوكالة.',

      externalWekalaMofaTasdekDatebeforesaudiEmbassyTasdeekGregDate:
        'تاريخ تصديق وزارة الخارجية السعودية لا يمكن أن يكون قبل تاريخ تصديق السفارة او القنصلية السعودية.',

      externalWekalaMofaTasdekDatebeforesaudiEmbassyTasdeekGregDate_1:
        'تاريخ تصديق وزارة الخارجية السعودية لا يمكن أن يكون قبل وزارة الخارجية للدولة المصدرة للوكالة.',

      externalWekalaMofaTasdekDatebeforesaudiEmbassyTasdeekGregDate_2:
        'تاريخ تصديق وزارة الخارجية السعودية لا يمكن أن يكون قبل تاريخ إصدار للوكالة.',

      externalWekalaSaudiTasdekDatebeforeForeignAffairsSourceCountryTasdeekGregDate:
        'تاريخ تصديق السفارة او القنصلية السعودية لا يمكن أن يكون قبل تاريخ تصديق وزارة الخارجية للدولة المصدرة للوكالة.',

      deleteSucces: 'تم حذف طلب التصديق رقم ',
      validationErrors: {
        fillAllRequiredFields: 'يجب ملئ جميع الحقول المطلوبة',
        addAndSaveRequesterFirst: 'يجب حفظ بيانات مقدم الطلب اولا',
        addAndSaveFirstPartyFirst: 'يجب حفظ بيانات الموكلين اولا',
        addAndSaveSecondPartyFirst: 'يجب حفظ بيانات الوكلاء اولا',
        addAndSaveTasdekInfoFirst: 'يجب إدخال و حفظ بيانات التصديق بشكل صحيح',
        AcceptDataFirst: 'الرجاء قبول التعهد أولاً',
        // sameIdAddedBefor: 'لا يمكن إضافة الطرف الحالى لانه مضاف من قبل',
        sameIdAddedBefor: 'عذراً، هذه الهوية مضافة',
        sameEmailAddedBefor:
          'لا يمكن إضافة الطرف الحالى بسبب تكرار البريد الإلكتروني',
        requesterSavedSuccesfuly: 'تم إضافة مقدم الطلب بنجاح',
        firstPartySavedSuccesfuly: 'تم إضافة الموكل بنجاح',
        secondPartySavedSuccesfuly: 'تم إضافة الوكيل بنجاح',
        firstPartyDeletedSuccesfuly: 'تم حذف الموكل بنجاح',
        secondPartyDeletedSuccesfuly: 'تم حذف الوكيل بنجاح',
      },
      delete: 'حذف الطلب',
      edit: 'تعديل الطلب',
      addnewfirstParty: 'إضافة موكل جديد',
      addnewSecondParty: 'إضافة وكيل جديد',
      identityInfoinExternalWekala: 'بيانات الهوية المسجلة فى الوكالة الخارجية',
      companyInfoinExternalWekala: 'بيانات الشركة المسجلة فى الوكالة الخارجية',
      identityType: 'نوع الهوية',
      insertIdentityMessage:
        'في حال وجود لدى الطرف هوية وطنية او إقامة يرجى إدخالها بالإضافة الى تعبئة حقل رقم الهوية المسجل في الوكالة الخارجية',
      NoinsertIdentityMessage:
        'فى حال لم يتم ذكر هوية الطرف فى الوكالة الخارجية يتوجب إضافة احد الهويات التى لها صلة به',

      firstPartySefa: 'صفة الموكل',
      firstPartyType: 'نوع الموكل',
      person: 'فرد',
      company: 'شركة',
      iqamaId: ' رقم الإقامة',
      mobileNo: 'رقم الجوال',
      email: 'البريد الالكترونى',
      GCCNumber: 'رقم الهوية',
      isThereExternalWekalaNumber: 'يوجد رقم وكالة خارجية',
      externalWekalaNumber: 'رقم الوكالة الخارجية',
      externalWekalaIssueDate: 'تاريخ إصدار الوكالة الخارجية',
      externalWekalaEndDate: 'تاريخ إنتهاء الوكالة الخارجية',
      externalTasdekWekalaEndDate: 'تاريخ إنتهاء تصديق الوكالة الخارجية',
      externalWekalaEndDateHint:
        'حسب الأنظمة المطبقة في المملكة العربية السعودية، ستصدر الوكالة لمدة 5 سنوات من تاريخ اصدار الوكالة الخارجية',
      externalWekalaCountry: 'الدولة المصدرة للوكالة الخارجية',
      externalWekalaSource: 'جهة إصدار الوكالة الخارجية',
      externalWekalaIssuePlace: 'اسم الجهة',
      externalWekalaIssueCountryTasdekDate:
        'تاريخ تصديق وزارة الخارجية للدولة المصدرة للوكالة الخارجية',
      externalWekalaSaudiTasdekDate: 'تاريخ تصديق السفارة أو القنصلية السعودية',
      externalWekalaMofaTasdekDate: 'تاريخ تصديق وزارة الخارجية السعودية',
      isThereExternalWekalaEndDate: 'يوجد تاريخ إنتهاء للوكالة الخارجية',
      tasadek: 'التصاديق',
      personInfo: {
        firstName: 'الاسم الأول',
        fatherName: 'اسم الأب',
        thirdName: 'اسم الجدّ',
        familyName: 'اسم العائلة',
        gender: 'النوع',
        male: 'ذكر',
        female: 'أنثى',
        nationality: 'الجنسية',
      },
      companyInfo: {
        crNumber: 'رقم السجل التجاري',
        companyName: 'اسم الشركة',
        companyNationality: 'جنسية الشركة',
      },
      MOFATasdek: 'تصديق وزارة الخارجية',
      APOSTILLE: ' تصديق أبوستيل Apostille',
      APOSTILLENumber: 'رقم تصديق أبوستيل',
      APOSTILLEDate: 'تاريخ تصديق أبوستيل',
      tasdekCode: 'رقم تصديق الوكالة الصادر من وزارة العدل',
      tasdekDate: 'تاريخ تصديق الوكالة',
      tasdeekDepartment: 'مكان التصديق',
    },
    cancelRequest: ' إلغاء الطلب',
    DeleteFirstParty: 'حذف موكل',
    QDeleteFirstParty: 'هل تريد حذف الموكل؟',
    DeleteSecondParty: 'حذف وكيل',
    QDeleteSecondParty: 'هل تريد حذف الوكيل؟',
    deleteRequest: ' حذف الطلب',
    editRequest: ' تعديل الطلب',
    cancelRequestTitel: 'هل أنت متأكد من إلغاء الطلب؟',
    cancelEditRequestTitel: 'هل أنت متأكد من إلغاء تعديل الطلب؟',
    TasdekDeleteRequestTitel: 'هل أنت متأكد من حذف الطلب رقم %{count}؟',
    TasdekEditRequestTitel: 'هل أنت متأكد من تعديل الطلب رقم %{count}؟',
    next: 'التالي',
    confirm: 'تأكيد',
    confirmAddFirstParty: 'موافق',
    continue: 'متابعة',
    stop: 'تراجع',
    StartFaskh: 'ابدأ الفسخ',
    landing: 'الرئيسية',
    procurationVerification: 'التحقق من وكالة',
    admissionVerifications: 'التحقق من إقرار',
    back: 'تراجع',
    backOtp: 'إلغاء',
    dashboard: 'لوحة المعلومات',
    previous: 'السابق',
    ProcurationsNotFound: 'لا توجد وكالات',
    accept: 'تأكيد',
    goBack: 'رجوع',
    goBackToHome: 'العودة للبوابة',
    newVerification: 'تحقق جديد',
    choose: 'اختر..',
    verify: 'تحقق',
    cancel: 'إلغاء',
    add: 'إضافة',
    proceed: 'اعتماد',
    sendRequest: 'تقديم الطلب',
    EditRequest: 'حفظ التعديلات',
    Groupedproceed: 'قبول',
    reject: 'رفض',
    isRequiredMessage:
      ' يجب تعبئة الحقول الإجبارية في البنود التي تم اختيارها والمشار لها بعلامة*',

    isAqariRequiredMessage: 'يجب التحقق من صحة الصكوك العقارية',
    isRequired: 'متطلب',
    send: 'إرسال',
    Groupedsend: 'تقديم الطلب',
    resend: 'إعادة إرسال',
    period: 'من {from} إلى {to}',
    documentNumber: 'رقم الوثيقة',
    wekalaNumber: 'رقم الوكالة',

    procurationDetails: {
      title: 'بيانات الوكالة',
      back: 'العودة',
      procurationText: 'نص الوكالة',
      isTogether: 'مجتمعين',
      isNotTogether: 'غير مجتمعين',
      valid: 'سارية',
      inValid: 'غير سارية',
      together: 'مجتمعين',
      notTogether: 'غير مجتمعين',
      wekalaActions: 'سجل الأحداث',
      WekalaInquiry: 'سجل الاستعلام',
      WekalaUsage: 'سجل الاستخدام',
      referenceNumber: 'الرقم المرجعي',
      ActionDate: 'التاريخ و الوقت',
      EntityName: 'اسم الجهة',
      Action: 'العملية',
      ActionPartySefa: 'صفة الطرف بالوكالة',
      ActionPartyName: 'اسم طرف الوكالة',
      ActionPartyIdentity: 'رقم الهوية',
      NoWekalaAction: 'لا يوجد سجل أحداث للوكالة',
      NoWekalaInquery: 'لا يوجد سجل استعلام للوكالة',
      NoWekalaUsage: 'لا يوجد سجل استخدام للوكالة',
      UsageWakelName: 'اسم الوكيل',
      UsageWakelNationalId: 'هوية الوكيل',
    },
    admissionDetails: {
      title: 'التحقق من إقرار',
      pageTitle: 'خدمات التحقق',
      info: 'تفاصيل الإقرار',
      description:
        'خدمة تساعدك على التحقق من صحة الإقرار الصادر من كتابات العدل',
      admissionNumber: 'رقم الإقرار',
      writeAdmissionNumber: 'رقم الإقرار',
      status: 'حالة الإقرار',
      issueDate: 'تاريخ الإصدار',
      issueSource: 'جهة الإصدار',
      partySidesInfo: 'بيانات الأطراف',
      declarer: 'مقر',
      declarerFor: 'مقر له',
      idNumber: 'رقم الهوية',
      idType: 'نوع الهوية',
      adjective: 'صفة الطرف',
      admissionDeed: 'صك الإقرار',
      back: 'العودة',
      download: 'تحميل صك الإقرار',
      writeIdNumber: 'رقم الهوية',
      noAgencyTerms: 'لا يوجد بنود',
      warning: 'رقم الإقرار أو رقم هوية أحد الأطراف غير صحيح',
      active: 'ساري',
      notaryName: 'اسم كاتب العدل',
      valid: 'ساري',
      inValid: 'غير ساري',
      confessee: 'مقر له',
      admissionInfo: 'بيانات الإقرار',
      typeName: 'نوع الإقرار',
    },

    procurations: {
      title: 'الوكالات',
      noData: 'لا يوجد',
      procurationNumber: 'رقم الوكالة',
      totalSearchCount: 'نتائج البحث المتقدم',
      totalSearchCountinterPo: 'نتائج البحث المتقدم: %{count} وكالات',
      totalSearchCountinterPoSing: 'نتائج البحث المتقدم: %{count} وكالة',
      tasdekNumber: 'رقم تصديق الوكالة الخارجية',
      subwekala: 'الوكالات الفرعية',
      mainWekalaCode: 'رقم الوكالة الأساسية',
      wakelName: 'اسم الوكيل',
      procurationType: 'نوع الوكالة',
      partyTypeName: 'صفة الطرف',
      issueDate: 'تاريخ إصدار الوكالة',
      tasdekIssueDate: 'تاريخ إصدار التصديق',
      sourceName: 'مصدر الوكالة',
      status: 'حالة الوكالة',
      tasdekStatus: 'حالة التصديق',
      CompanyRepresentatorName: 'اسم ممثل المنشأه',
      expiryDate: 'تاريخ انتهاء الوكالة',
      tasdekExpiryDate: 'تاريخ انتهاء التصديق',
      partyStatus: 'حالة الطرف',
      delete: 'فسخ الوكالة',
      deleteProcuration: 'لقد تم فسخ الوكالة بنجاح',
      dialogHeader: 'الصفة في الوكالة',
      terminateProcuration: 'هل تريد فسخ الوكالة؟',
      warning:
        'تنبيه، عند اعتماد الفسخ تصبح الوكالة غير سارية لطالب الفسخ لأي إجراء مستقبلاً. و سيتم إشعار جميع أطراف الوكالة بهذا الفسخ',
      agentName: 'اسم الوكيل',
      clientName: 'اسم الموكل',
      checkAll: 'الكل',
      choosePartyType: 'اختر الصفة في الوكالة',
      emptyListTitle: 'لا يوجد وكالات لعرضها',
      emptyListDescription: 'يمكنك إنشاء وكالة عن طريق الضغط على الرابط أدناه',
      createNewAttorny: 'إنشاء وكالة جديدة',
      qaimHeaderFask: 'تم فسخ الوكالة بنجاح',
      NoRequests: 'عذراً لايوجد طلبات حالياً',
      NoDrafts: 'عذراً لايوجد مسودات حالياً',
      NoWekalas: 'عذراً لايوجد وكالات حالياً',
      subWekala: {
        procurationNumber: 'رقم الوكالة الفرعية',
        issueDate: 'تاريخ إصدار الوكالة الفرعية',
        expiryDate: 'تاريخ انتهاء الوكالة الفرعية',
        wakelName: 'اسم الوكيل بالوكالة الأساسية',
        status: 'حالة الوكالة الفرعية',
      },
      reIssue: 'إعادة إصدار الوكالة',
    },
    requests: {
      requestNumber: 'رقم الطلب',
      requestDate: 'تاريخ الطلب',
      requester: 'مقدم الطلب',
      status: 'حالة الطلب',
      firstPartyCount: 'عدد الموكلين',
      secondPartyCount: 'عدد الوكلاء'
    },
    drafts: {
      draftNumber: 'رقم المسودة',
      requestDate: 'تاريخ إنشاء المسودة',
      requesExpireDate: 'تاريخ إنتهاء صلاحية المسودة',
      timerRequesExpireDate: 'الوقت المتبقي',
      requestType: 'نوع الوكالة',
      status: 'حالة الطلب',
      delete: 'حذف',
      deleteTitle: 'حذف المسودة',
      resumeTitle: 'استكمال مسودة',
      deleteDraftMessage: 'هل أنت متأكد من حذف المسودة رقم {cnt} ؟',
      deleteDraftSuccessMessage: 'تم حذف المسودة بنجاح',
      Verify: 'تحقق',
      Continue: 'استكمال',
      Continuepopup: 'استكمال المسودة',
      DeleteContinue: 'حذف المسودة',
      SaveLater: 'حفظ المسودة',
      Close: 'إغلاق',
      VerifySuccessMessageFirstParty: 'تم التحقق من الموكل بنجاح',
      VerifySuccessMessageSecondParty: 'تم التحقق من الوكيل بنجاح',
      VerifyFirstPartyFirst: 'عذراً ، يجب التحقق من الموكل لتتمكن من استكمال المسودة | عذراً ، يجب التحقق من الموكلين لتتمكن من استكمال المسودة ',
      VerifySecondPartyFirst: 'عذراً ، يجب التحقق من الوكيل لتتمكن من استكمال المسودة | عذراً ، يجب التحقق من الوكلاء لتتمكن من استكمال المسودة ',
      SecondParty: 'الوكيل | الوكلاء',
      FirstParty: 'الموكل | الموكلين ',
      SaveDraftSuccessMessage: 'تم حفظ المسودة برقم:  {cnt} بنجاح',
      youCanSeeDraftListWithinTime: 'يمكنك الاطلاع على المسودة من قائمة المسودات وإجراء التعديلات عليها واعتمادها أو حذفها خلال المدة الزمنية المحددة',
      draftType: 'نوع الحفظ',
      manualDraft: 'يدوي',
      autoDraft: 'تلقائي',
      draftDiscription: 'خدمة تمكنك من استكمال المسودات المحفوظة سابقاً',
      groupedBuilder: 'وكالة متعددة الأطراف',
      singleBuilder: 'وكالة فردية',
      saveDraft: 'حفظ كمسودة',
      continueDraftMessage: 'يوجد لديك مسودة وكالة محفوظة تلقائياً عبر النظام لحفظ وقتك وجهدك ، يمكنك استكمالها حالياً أو حفظها لاعتمادها بوقت لاحق أو حذفها',
      draftInfo: 'معلومات المسودة'
    },
    anonymousUserVerification: {
      dialogs: {
        verfiyAnonymousUserDialog: 'التحقق من الهوية',
        idNumber: 'رقم الهوية',
        dateOfBirth: 'تاريخ الميلاد',
        verify: 'تحقق',
        back: 'إلغاء',
        otpCode: 'رمز التحقق',
        resend: 'إعادة إرسال',
        alertText: 'الوقت المتبقي لانتهاء المدة المسموحة:',
        otpPlaceHolder:
          'الرجاء إدخال رمز التحقق المرسل إلى جوالك المسجل في أبشر',
      },
    },
    query: {
      title: 'الإقرارات',
      admissionNumber: 'رقم الإقرار',
      procurationNumber: 'رقم الوكالة',
      procurationType: 'نوع الوكالة',
      partyTypeName: 'صفة الطرف',
      issueDate: 'تاريخ الإصدار',
      sourceName: 'المصدر',
      status: 'حالة الطلب',
      notaryName: 'اسم كاتب العدل',
      titelSearch: 'تصفية نتائج البحث',
      searchBtn: 'بحث',
      emptyListTitle: 'لا يوجد إقرارات لعرضها',
      clientNationalId: 'رقم هوية الوكيل',
      agentNationalId: 'رقم هوية الموكل',
      creatorNationalId: 'رقم هوية ممثل المنشأة',
      companyRepresentitveNationalId: 'رقم هوية ممثل المنشأه',
      tasdekRequestnumber: 'رقم التصديق',
      tasdekRequestnumberQ: 'رقم الطلب',
      fromDate: 'من تاريخ',
      toDate: 'الى تاريخ',
    },
    calendar: {
      miladiDate: 'التاريخ الميلادي',
      hijriDate: 'التاريخ الهجري',
    },
    copyWekala: {
      AgentToCopy: 'بيانات الوكيل في الوكالة المنسوخة رقم',
      AgentToReIsuue: 'بيانات الوكيل في الوكالة رقم',
      MowakelToCopy: 'بيانات الموكل في الوكالة المنسوخة رقم',
      MowakelToReIsuue: 'بيانات الموكل في الوكالة رقم',
      copyWekalaHint:
        'هي خدمة تتيح للمستفيد نسخ وكالة صادرة مُسبقاً بهدف تقليل الجهد والوقت في إضافة الموكلين والوكلاء واختيار بنود الوكالة',
      clausesSuccess: 'تم نسخ بنود الوكالة بنجاح',
      clausesAndAgentsSuccess: 'تم نسخ البنود و الوكلاء بنجاح',
      wekalaNumber: 'رقم الوكالة المُراد نسخها',
      idNumber: 'رقم هوية أحد أطراف الوكالة المُراد نسخها',
      cancel: 'تراجع',
      copyClausesSuccess:
        'تم نسخ بنود الوكالة رقم: %{count} بنجاح ',
      copyClausesAndPartiesSuccess:
        'تم نسخ بنود و أطراف الوكالة رقم: %{count} بنجاح ',
      generalCopyMessage: 'تم نسخ %{copyType} من الوكالة رقم: %{code} بنجاح'
    },
    Qaim: {
      FooterText: 'الخدمات الإلكترونية لوزارة العدل',
      HeaderText: 'الخدمات الإلكترونية لوزارة العدل',
      VerificationHeaderText: 'تم التحقق من الوكالة بنجاح',
    },

    attorneyRegistration: {
      send: 'اعتماد',
      checkOTP: 'تحقق',
      Groupedsend: 'قبول',
      IssueSingle: 'إصدار وكالة',
      CompanyIssueSingle: 'إصدار وكالة',
      ExTasdek: 'تصديق وكالة خارجية',
      IssueGrouped: 'إصدار وكالة متعددة الأطراف',
      IssueCopy: 'نسخ وكالة',
      ServiceDiscription: 'شرح الخدمة',
      IssueSingleDiscription:
        'خدمة تمكنك من إصدار وكالة لموكل واحد مع وكيل / عدة وكلاء',
      ExTasdekDiscription: 'خدمة تمكنك من تقديم طلب تصديق وكالة خارجية',
      IssueCopyDiscription:
        'خدمة تمكنك من نسخ وكالة صادرة مُسبقاً بهدف تقليل الجهد والوقت في إضافة الموكلين والوكلاء واختيار بنود الوكالة',
      IssueGroupedDiscription:
        'خدمة تمكنك من إصدار وكالة بأكثر من موكل في الوكالة الواحدة، تصدر خلال',
      selectedIdentity: 'نوع الهوية',
      nationality: 'الرجاء اختيار الجنسية',
      nationalityDisp: 'الجنسية',
      title: 'إصدار وكالة',
      Groupedtitle: 'طلب إصدار وكالة إلكترونية متعددة الأطراف',
      noClausesBemogabwekala:
        'لا يوجد بنود متشابهة بين الوكالات الأساسية المختارة',
      prohiptedMessage: 'تم إخفاء بعض البنود المالية لوجود منع جزئي على الموكل',
      companyNotAllowedToCreateWekala: 'يمكن إصدار وكالة عن طريق ناجز أعمال في حال كانت المنشأة "مؤسسة فردية" فقط ، غير ذلك يكون عن طريق رفع طلب بكتابة العدل الإفتراضية عبر بوابة ناجز',
      companyNotAllowedToCreateWekalaTes: 'يمكن إصدار وكاشأة "مؤسسة فردية" فقط ،بة ناجز',
      prisonerNotAllowedToCreateWekala: 'لا يمكن إنشاء وكالة متعددة الاطراف لسجين',
      prisonerNotAllowedToCopyWekala: 'لا يمكن نسخ وكالة لسجين',
      copyWekalaCount_1: 'تم نسخ',
      copyWekalaCount_2: 'من أصل',
      copyWekalaCount_3: 'بند',
      conditions: 'لعدم مطابقة الشروط',
      copyWekalaCount_4: 'تم نسخ كافة البنود',

      partiesInfo: 'بيانات الأطراف',
      FirstPartyInfo: 'بيانات الموكل',
      SecondPartyInfo: 'بيانات الوكيل',
      WekalaClauses: 'بنود الوكالة',
      WekalaDuration: 'مدة الوكالة',
      WekalaPreview: 'معاينة الوكالة',
      client: 'بيانات الموكل',
      partySefaError: 'الرجاء تحديد صفة الموكل',
      duplicateAgentError: 'لا يمكن إضافة هذا الشخص لأنه مدخل في طرف الوكيل',
      duplicatePartiesError: 'لا يمكن إضافة هذا الشخص لأنه مدخل في طرف الموكل',
      duplicateCompanyError:
        'لا يمكن إضافة هذه المنشأه لأنها مدخلة في طرف الموكل',
      duplicateFirstPartiesError: 'لا يمكن إضافة موكل تم إضافته مسبقاً',
      duplicateBemogabwekalaPartiesError:
        'لا يمكن إضافة وكيل موجود في الوكالة الأصلية بصفة موكل ',
      duplicateBemogabwekalaSecondPartiesError:
        'لا يمكن إضافة وكيل موجود في الوكالة الأصلية بصفة وكيل ',
      agent: 'بيانات الوكيل',
      addAgent: 'إضافة وكيل',
      attorneyDuration: 'مدة الوكالة',
      attorneyStartDate: 'تاريخ بداية الوكالة',
      attorneyEndDate: 'تاريخ نهاية الوكالة',
      mobileWarning:
        'يجب إدخال رقم جوال المستفيد بشكل صحيح لضمان استلامه لصك الوكالة الإلكتروني',
      warning: 'مدة الوكالة الإلكترونية ثلاثة أشهر فقط من تاريخ إصدارها',
      attorneyExp: 'تاريخ انتهاء الوكالة',
      edit: 'تعديل',
      grouped: 'يجب أن يكون الوكلاء مجتمعين عند استخدام هذه الوكالة',
      newAgent: 'إضافة وكيل جديد',
      newClient: 'إضافة موكل',
      newClientManual: 'إضافة موكل جديد ',
      newClienthead: 'إضافة موكل',
      deleteAgent: 'حذف الوكيل',
      delete: 'حذف',
      cancelAddClient: 'إلغاء إضافة موكل',
      cancelAddAgent: 'إلغاء إضافة وكيل',
      editAgent: 'تعديل',
      deleteAgentSuccess: 'تم حذف الوكيل بنجاح',
      deleteAgentError: 'حدث خطأ أثناء حذف الوكيل الرجاء إعادة المحاولة',
      addAgentSuccess: 'تم إضافة الوكيل بنجاح',
      addClientSuccess: 'تم إضافة الموكل بنجاح',
      issuingDate: 'تاريخ إصدار الوكالة',
      expiryDate: 'تاريخ انتهاء الوكالة',
      expiryDateUpdateSuccess: 'تم تحديث تاريخ انتهاء الوكالة بنجاح',
      partyType: 'صفة الطرف',
      agentOfAgency: 'وكيل بموجب وكالة',
      forHimself: 'أصالة عن نفسه',
      nationalId: 'هوية وطنية',
      residentId: 'إقامة',
      office: 'مكتب',
      idType: 'نوع الهوية',
      attorneyId: 'رقم الصك بالوكالة',
      idNumber: 'رقم الهوية',
      attorneyInfo: 'معلومات الوكالة',
      oneMonth: 'شهر',
      twoMonths: 'شهرين',
      threeMonths: 'ثلاثة شهور',
      sixMonths: 'ستة شهور',
      nineMonths: 'تسعة شهور',
      oneYear: 'سنة',
      months: 'أشهر',
      hijri: 'هجري',
      gregorian: 'ميلادي',
      manually: 'أو اختر المدة يدوياً',
      durationTitle: 'الرجاء تحديد مدة الوكالة',
      commercialId: 'رقم السجل التجاري لمكتب الاستقدام ',
      chooseAttorney: 'اختيار الوكالة المطلوبة',
      requestConfirmation: 'معاينة الطلب',
      otpDescription:
        'الرجاء إدخال رمز التحقق المؤقت المرسل إلى الجوال المسجل في أبشر',
      nafathOtpDescription: 'الرجاء التحقق من تطبيق نفاذ',
      fpDescription:
        'الرجاء التحقق من البصمة',
      temporaryPassword: 'كلمة المرور المؤقتة',
      timeAlertText: 'الوقت المتبقي لانتهاء المدة المسموحة:',
      attorneyDetails: {
        title: 'تفاصيل الوكالة',
        client: 'موكل',
        agent: 'وكيل',
        attorneyPreview: 'معاينة الوكالة',
        attorneyType: 'نوع الوكالة',
        grouped: 'يجب أن يكون الوكلاء مجتمعين عند استخدام هذه الوكالة',
        resultDescription: 'تم إصدار وكالة إلكترونية رقم : %{code} بنجاح ',
        tasdekResultDescription: 'تم تقديم طلب تصديق وكالة خارجية رقم : ',
        tasdekResultDescriptionpopup: 'تم إصدار طلب تصديق وكالة خارجية برقم : ',
        tasdekResultDescriptionpopupREV: 'تنبيه: يجب اعتماد الطلب خلال 60 يوم  من إصدار الطلب، من خلال احد فرع وزارة العدل بالمملكة لاستكمال إجرائات التصديق ويتوجب وجود اصل الوكالة الخارجية',

        editTasdekResultDescription: 'تم تعديل طلب تصديق وكالة خارجية رقم : ',
        resultDescriptionSuccess: 'تم إصدار وكالة إلكترونية بنجاح ',
        GroupedresultDescriptionSuccess: 'تم تقديم طلب وكالة إلكترونية بنجاح ',
        resultDescriptionSuccessWekalaNo: 'رقم الوكالة : %{count}',
        GroupedresultDescriptionSuccessWekalaNo: 'رقم الطلب : %{count}',
        grpresultDescription:
          'تم إرسال طلب وكالة إلكترونية متعددة الأطراف رقم : ',
        GroupedresultDescription: 'تمت عملية المصادقة على الطلب رقم : ',
        Success: ' بنجاح ',
        SmsNotify:
          'ستصل رسالة نصية لكافة الأطراف (الموكل/الوكيل) ويمكن الاطلاع على الوكالة عبر "بوابة ناجز" أو "تطبيق ناجز" على الأجهزة الذكية',

        SmsNotifyEdit:
          'سيتم التحقق من كافة التعديلات، وابلاغكم بنجاح عملية التعديل من خلال رسالة نصية للرقم الخاص بكم المسجل في ابشر',

        AttorneyCode: 'كود الوكالة: ',
        GroupedApproveRequest: 'تم قبول الطلب بنجاح',
      },
      GroupedRequestDetails: {
        title: 'تفاصيل الطلب',
        rejectionReason: 'سبب الرفض',
        AcceptRequest: 'قبول الطلب',
        AcceptRequestCeckBox:
          'أقر وأتعهد أنا الموضحة بياناتي أعلاه بصحة البيانات المدخلة في الطلب، وأتحمل مسؤولية ما يترتب على ذلك.',
        requestNumber: 'رقم الطلب',
        requestCreationDate: 'تاريخ الطلب',
        requestEndDate: 'تاريخ انتهاء الوكالة المطلوب إصدارها',
        requestTracking: 'تتبع حالة الطلب',
        client: 'موكل',
        agent: 'وكيل',
        attorneyPreview: 'معاينة الوكالة',
        attorneyType: 'نوع الوكالة',
        grouped: 'يجب أن يكون الوكلاء مجتمعين عند استخدام هذه الوكالة',
        resultDescription: 'تم إصدار طلب وكالة إلكترونية متعددة الأطراف رقم : ',
        resultDescription_2: 'تم إصدار طلب وكالة إلكترونية متعددة الأطراف رقم :  {cnt}  بنجاح',
        SmsNotify:
          'سيتم اعتماد الوكالة عند مصادقة جميع الموكلين أو عند انقضاء 48 ساعة',
        SmsNotify_2:
          'وتم إرسال رسالة نصية لكافة الموكلين للإطلاع على تفاصيل الطلب والمصادقة بالقبول أو الرفض ، علماً بأنه سيتم اعتماد الوكالة عند اكتمال مصادقة جميع الموكلين أو عند انتهاء المدة الزمنية المحددة (48 ساعة)',
        AttorneyCode: 'كود الوكالة: ',
        createRequestTimeLine: 'تم إرسال طلب إصدار وكالة متعددة الأطراف',
        groupedFirstPartyStatus: 'حالة الموكلين بالطلب',
        createWekalaTimeLine: 'تم إصدار الوكالة رقم ',
        timeLineApprove: 'تم قبول الطلب',
        timeLineReject: 'تم رفض الطلب',
        timeLinePending: 'بانتظار قبول / رفض الطلب  ',
        timeLineRequester: '(مقدم الطلب)',
      },
      commercialDate: 'تاريخ إصدار السجل التجاري',
      commercialName: 'اسم المكتب',
      commercialNumber: 'تم التحقق من رقم المنشأة الموحد',
      officeWarning: 'رسالة تنبيه',
      commercialstatus: 'حالة المكتب',
      agency: 'الوكالة',
      staticText: 'نص ثابت',
      searchText: 'عن ماذا تبحث؟',
      searchTextCluases: 'البحث في البنود',
      searchTextAttType: 'ابحث عن نوع الوكالة',
      chooseProcuration: 'اختيار الوكالة المطلوبة',
      previewRequest: 'معاينة الطلب',
      clausesSelection: 'ملخص البنود',
      phoneNumberMsg: 'يرجى منكم تعبئة البيانات التالية لإكمال طلبكم',
      phonePopupTitle: 'إكمال البيانات الشخصية',
      phonePlaceholder: 'الرجاء إدخال رقم الجوال',
      items: 'عناصر',
      chosenitems: 'تم اختيار',
      aqariIdNumber: 'رقم هوية المالك أو أحد الملاك',
      aqariIdType: 'نوع هوية المالك أو أحد الملاك',
      aqariVerfy: 'تحقق',
      aqariVerfySuccess: 'تم التحقق من الصك المدخل بنجاح',
      aqariVerfyFillRequired: 'يجب ملئ رقم الصك و رقم الهوية و نوع الهوية',
      item: 'عنصر',
      from: 'من',
      phoneNumberWarning:
        'يجب إدخال رقم جوال المستفيد بشكل صحيح لضمان استلامه لصك الوكالة الإلكتروني',
      durationWarning:
        'مدة الوكالة الإلكترونية ثلاثة أشهر فقط من تاريخ إصدارها',
      clausesSelectedWarning: 'لايمكن إتمام إصدار وكالة دون اختيار بند واحد على الأقل',
      hideJudicalClauses: 'سيتم إخفاء البنود الخاصة بالمطالبات و المحاكم',
      hideJudicalClausesInClauses: 'سيتم إخفاء البنود الخاصة بـ" المطالبات و المحاكم " لوجود احد الوكلاء بصفة أصالة عن نفسه',
      fourthRelationAgreement: 'أتعهد بأن صاحب الهوية رقم  %{count} يعتبر من الفئات المشمولة بالفقرة (أ) من المادة (18) من نظام المحاماة وهم: الأزواج أو الأصهار أو الأشخاص من ذوي القربى، حتى الدرجة الرابعة',
      firstPartyShouldVerifyMessage: 'يتطلب مصادقة الموكل المضاف لاعتماد الوكالة وإصدارها',
      addAnotherFirstParty: 'إضافة موكل آخر'
    },
    personalInfo: {
      idType: 'نوع الهوية',
      saudiId: 'هوية وطنية',
      bemogabwekalaLegend: 'وكيل بموجب وكالة',
      MaxBemogabwekala: 'الحد الأقصى 10 وكالات',
      idNumber: 'رقم الهوية',
      iqamaNumber: 'رقم الإقامة',
      crNumber: 'رقم المنشأة الموحد',
      passportNumber: 'رقم جواز السفر',
      hafizaNumber: 'رقم الحفيظة',
      femailSakNumber: 'مثبت بلوغها بموجب الصك رقم',
      birthDate: 'تاريخ الميلاد',
      name: 'الاسم',
      nationality: 'الجنسية',
      gender: 'النوع',
      female: 'أنثى',
      male: 'ذكر',
      validate: 'تحقق',
      phoneNumber: 'رقم الجوال',
      companyName: 'اسم المنشأه',
      companyNationalNumber: 'الرقم الوطني الموحد',
      commercialRecordNumber: 'رقم السجل التجارى',
      bemogab: 'بموجب',
      bemogabWekala: 'بموجب وكالة',
      bemogabWekalaLabel: 'رقم الوكالة الأساسية',
      commercialBemogab: 'السجل التجاري',
      commercialRecordNumberBemogab: 'رقم المنشأة الوطني',
      firstName: 'الاسم الأول',
      fatherName: 'اسم الأب',
      grandFatherName: 'اسم الجد',
      familyName: 'اسم العائلة',
      representer: 'الصفة',
      type: 'النوع',
      relativeRelationToWitnesses: 'صلة قرابة الشاهد بمقدم الطلب',
      relativeRelation: 'صلة القرابة',
      note: 'ملاحظة',
      residence: 'محل الإقامة',
      passportSource: 'مصدر جواز السفر',
      HafezaSource: 'مصدر الحفيظة',
      passportDate: 'تاريخ جواز السفر',
      HafizaDate: 'تاريخ الحفيظة',
      PartySefa: 'صفة الموكل',
      SecondPartySefa: 'صفة الوكيل',
      BemogabWekalaNumber: 'رقم الوكالة',
      editPartySefa: 'تعديل الصفة',
      passportIssueDate: 'تاريخ إصدار جواز السفر',
      passportExpireDate: 'تاريخ انتهاء جواز السفر',
    },
    companyInfo: {
      companyPersonsTypeName: 'صفته بالشركة',
      accordingToTypeDate: 'تاريخ إصدار السجل التجاري',
      establCounter: 'رقم نسخة العقد',
      establCounterDate: 'تاريخ نسخة العقد',
      investmentLicenseNo: 'رقم ترخيص الاستثمار',
      investmentLicenseNoDate: 'تاريخ إصدار الرخصة',
      investmentLicenseNoSrc: 'الصادر من'
    },
    BemogabWekala: {
      wekalaCode: 'وكالة رقم: ',
      wekalaCodeVer: 'تم التحقق من الوكالة رقم :',
      issueDate: 'تاريخ الإصدار: ',
      endDate: 'تاريخ الانتهاء: ',
      onBehalfParties: 'الأطراف المراد التوكيل عنهم: ',
      adjective: 'الصفة',
      idType: 'نوع الهوية: ',
      idNumber: 'رقم الهوية: ',
    },
    Faskh: {
      OtpPlaceHolder: 'أدخل رمز التحقق',
      OtpTitle: 'رمز التحقق',
      confirm: 'إرسال',
      confirmFaskh: 'اعتماد الفسخ',
      sefaPopupTitle: 'في حال اعتماد فسخ الوكالة سيتم إجراء الفسخ إلكترونياً وإشعار كافة أطراف الوكالة برسالة نصية',
      close: 'إغلاق',
    },
    errs: {
      NotAllowedForSaudi:
        'غير مسموح للمواطن السعودي بالتسجيل في النظام بهوية غير سجل مدني',
      maxFirstPartyCount: 'غير مسموح بإضافة أكثر من {cnt} موكل',
      maxSecondPartyCount: 'غير مسموح بإضافة أكثر من {cnt} وكيل',
      currentUserShouldbeAdded: 'يجب إضافة مقدم الطلب كموكل',
      GroupedRequestShouldHaveMoreThanFirstParty:
        'يجب إضافة أكثر من موكل في طلب الوكالة متعددة الأطراف',
      FillCurentFirstPartyFirst: 'يجب تأكيد بيانات مقدم الطلب كـ"موكل" أولاً لتتمكن من إضافة موكل آخر',
    },
    errors: {
      VallidationFailed: 'يرجى التحقق من البيانات والمحاولة مرة أخرى',
      age: 'لا يمكن إضافة طرف عمره أقل من 18 سنة',
      AddMowakelFirst: 'الرجاء إدخال بيانات الموكل و حفظها أولا',
      GroupedCheckBoxErr: 'الرجاء قبول التعهد أولاً',
      NotAllowedForSaudi: 'مسموح للمواطن السعودي توكيل مواطن أو مكتب فقط',
      TrainerLawyerNotAllowedForCopy: 'صفة محامي متدرب مسموح بها لموكل من نوع وكيل بموجب وكالة فقط',
      FillRequiredFeilds: 'الرجاء ملئ جميع الحقول المطلوبة',
      OfficeNotAllowedInGroupedWekala:
        'غير مسموح إضافة وكيل من نوع مكتب استقدام في طلب الوكالة متعددة الأطراف',
      GroupedAddMowakelFirst: 'الرجاء إدخال بيانات الموكلين و حفظها أولا',
      AddWakelFirst: 'يرجى إضافة الوكيل / الوكلاء و إختيار الصفة',
      englishWakel: 'لا يمكن إضافة وكيل اسمه مسجل باللغة الإنجليزية',
      invalidCrNumber: 'رقم المنشأة الموحد يجب أن يبدأ بـ 7',
      allowedNumbersOnly: 'مسموح إدخال أرقام فقط',
      EnglishNamePleaseInsertArabicName:
        'هذا الشخص اسمه مسجل باللغة الإنجليزية لدى وزارة الداخلية الرجاء كتابة الاسم بالعربية',
      FillPassportDataCoorectly: 'يجب ملئ بيانات جواز السفر كاملة',
      FillWekalaEndDate: 'يرجى اختيار تاريخ انتهاء الوكالة',
      FingurePrintErrorTryAgain: "خطأ اثناء التحقق من البصمة الرجاء إعادة المحاولة"
    },
    admissionVerification: {
      confessor: 'مقر',
      confessee: 'مقر له',
      admissionNumber: 'إقرار رقم ',
      source: 'المصدر',
      issueDate: 'تاريخ الإصدار',
      partiesInfo: 'بيانات الأطراف',
      idNumber: 'رقم الهوية',
      adjective: 'الصفة',
      issuePlace: 'مكان الإصدار',
      typeName: 'نوع الإقرار',
    },
    experimentalCopy: {
      title: 'نسخة تجريبية',
      bodyMessage:
        'في حال رغبت بالرجوع للخدمة في البوابة القديمة فيمكن الوصول إليها',
      dialogHeader: 'العودة للنسخة السابقة',
      dialogBody: 'يهمنا سماع ملاحظاتكم لتطوير الخدمة من خلال التواصل العدلي',
      backToOldVersion: 'الذهاب للنسخة القديمة',
      pressHere: 'اضغط هنا',
    },
    SefaProps: {
      lawyerLicense: 'رقم رخصة المحامي',
      trainerLawyerLicense: 'رقم رخصة المحامي المتدرب',
      lawyerLicenseissueDate: 'تاريخ إصدار الترخيص',
      lawyerLicenseexpiryDate: 'تاريخ إنتهاء الترخيص',
      lawyerLicenceStatus: 'حالة رخصة المحامي',
      trainerLawyerLicenceStatus: 'حالة رخصة المحامي المتدرب'
    },
    SefaInfoDialog: {
      _35: 'رسالة المحامي',
      _36: 'رسالة قريب حتى الدرجة الرابعة',
      _1: `تم حصر اختيار بنود " المطالبات والمحاكم " على صفتي محامي أو قريب حتى الدرجة الرابعة <br>حسب

<b>المادة الثامنة عشرة من نظام المحاماة:</b>

<br>للمحامين المقيدين في جدول الممارسين دون غيرهم، حق الترافع عن الغير أمام المحاكم أو ديوان المظالم ، أو اللجان المشار إليها في المادة الأولى من هذا النظام. <br><b>واستثناء من ذلك يقبل للترافع عن الغير من يأتي :</b>
<br>أ - الأزواج أو الأصهار أو الأشخاص من ذوي القربى، حتى الدرجة الرابعة.`
    },
    favoritePerson: {
      cancel: 'إلغاء',
      add: 'إضافة',
      identityNumber: 'رقم الهوية',
      name: 'الاسم',
      addFirstPartyFromFavoriteList: 'إضافة موكل من المفضلة',
      addSecondPartyFromFavoriteList: 'إضافة وكيل من المفضلة',
      addPersonTofavorite: 'إضافة الطرف إلى قائمة المفضلة',
      partyAddedSuccessfully: 'تم الإضافة لقائمة المفضلة بنجاح',
      favoriteList: 'قائمة المفضلة',
      noFavoritePerson: 'عذراً قائمة المفضلة فارغة',
      identityType: 'نوع الهوية',
      mobileNo: 'رقم الجوال',
      fullName: 'الاسم',
      gender: 'النوع',
      nationality: 'الجنسية',
      searchName: 'الاسم',
      pageTitle: 'قائمة المفضلة',
      removePersonFromfavorite: 'حذف من قائمة المفضلة',
      partyDeletedSuccessfully: 'تم الحذف من قائمة المفضلة بنجاح',
      birthDate: 'تاريخ الميلاد',
      edit: 'تعديل',
      delete: 'حذف',
      deletePersonMessage: 'هل أنت متأكد من حذف ({cnt})  من قائمة المفضلة؟',
      favoritePersonDetail: 'تفاصيل المفضل',
      favoritePersonEdit: 'تعديل المفضل',
      passportNo: 'رقم جواز السفر',
      passportSource: 'مصدر جواز السفر',
      passportDate: 'تاريخ جواز السفر',
      partyUpdatedSuccessfully: 'تم حفظ التعديلات بنجاح',
      AddNewPerson: 'إضافة لقائمة المفضلة',
      AddNewPersonToFavorite: 'إضافة لقائمة المفضلة',
      favoriteConfig: 'إعدادات قائمة المفضلة',
      addMowkelFromFavorite: 'إضافة موكل من المفضلة',
      addWakeelFromFavorite: 'إضافة وكيل من المفضلة',
      deletePersonMessageBody: 'هل أنت متأكد من حذف ({cnt})  من قائمة المفضلة؟',
      addPersonMessageBody: 'هل أنت متأكد من إضافة ({cnt})  الى قائمة المفضلة؟',
      searchCount: 'عدد الأفراد : فرد |عدد الأفراد : فردان |عدد الأفراد :{count}أفراد |عدد الأفراد :{count} فرد',
      totalCount: 'إجمالي العدد : {count} ',
      favoriteServiceDiscription: 'هي خدمة تتيح للمستفيد إضافة أطراف الوكالة من قائمة المفضلة المحفوظة مُسبقاً بهدف تقليل الجهد والوقت',
      noFavoritePersonSearchResult: 'عذراً لا يوجد نتائج',
      infiniteScrollTitle: 'قائمة المفضلة',
      infiniteScrollSelectedTitle: 'قائمة المختارين',
      addWithPassport: 'إضافة بيانات جواز السفر',
      passportIssueDate: 'تاريخ إصدار جواز السفر',
      passportExpireDate: 'تاريخ انتهاء جواز السفر',
    },
    reIssue: {
      reIssueDialog: 'سيتم إعادة إصدار الوكالة برقم وكالة جديد، علمًا بأنه يمكنك إجراء أي تعديلات على الوكالة قبل الاعتماد'
    },
      nafathDialogs: {
        back: 'إلغاء',
        nafathPlaceHolder: 'الرجاء فتح تطبيق نفاذ واختيار الرقم الظاهر في الشاشة',
        nafathheaderTitle: 'تأكيد رمز التحقق ',
        nafathGeneralError: 'حدث خطأ فني أثناء تنفيذ العملية يرجى المحاولة مرة أخرى'
      },
    },
};

const i18n = new VueI18n({
  locale: 'ar',
  messages,
  pluralizationRules: {
    'ar': function (choice, choicesLength) {
      if (choicesLength > 2) {
        if (choice === 1) return 0; // صيغة المفرد
        if (choice === 2) return 1; // صيغة المثنى
        if (choice >= 3 && choice <= 10) return 2; // صيغة الجمع القليل
        return 3; // صيغة الجمع الكثير
      } else {
        return choice === 1 ? 0 : 1; // صيغة المفرد or صيغة المثنى
      }
    }

  }
});

export default i18n;
